// Import necessary modules and hooks from React Router and React
import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";

export const PublicRoute = ({ redirectPath = '/map' }) => {
    const { user } = useAuthContext();

    const [token, setToken] = useState(null);

    useEffect(() => {
        setToken(localStorage.getItem('nova_videowall_accessToken'));
    }, [user]);

    if (token) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
}
